module.exports = __webpack_public_path__ + "img/rowB2.2ef602ae.png";